<template>
  <section class="share-idea">
    <div class="container">
      <TitleWithLines
        v-if="data.title"
        :title="data.title"
        class="share-idea__title"
      />

      <div class="share-idea__content">
        <div class="share-idea__content-wrapp">
          <div
            class="share-idea__description"
            v-html="data.description"
          />

          <div class="share-idea__btn">
            <BaseButton
              @click="showModal"
            >
              {{ data.buttonTitle }}
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import TitleWithLines from '@/components/shared/TitleWithLines'
  export default {
    name: 'ShareIdeaBlock',

    components: { TitleWithLines },

    props: {
      data: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      showModal () {
        this.bus.$emit('showModal')
      }
    }
  }
</script>

<style lang="scss">
.share-idea {
  padding-top: 192px;
  overflow: hidden;

  @include mobile {
    padding-top: 96px;
  }

  &__title {
    svg {
      top: auto;
      bottom: 70px;

      @include mobile {
        bottom: 28px;
      }
    }
  }

  &__content {
    display: flex;
    justify-content: flex-end;
    background-color: $c-yellow;
    padding: 128px 230px 72px;
    margin-top: -70px;
    color: $c-black;

    @include tablet {
      padding: 128px 100px 72px 230px;
    }

    @include mobile {
      margin-top: -30px;
      padding: 64px 35px 36px 101px;
    }

    &-wrapp {
      width: 100%;
      max-width: 440px;
    }
  }

  &__description {
    max-width: 100%;
    font-size: 24px;
    line-height: 1.34;

    @include mobile {
      font-size: 14px;
    }
  }

  &__btn {
    margin-top: 40px;

    @include mobile {
      margin-top: 20px;
    }
  }
}
</style>
